<template>
  <div>
    <div v-if="error" class="error" v-html="error"></div>

    <div class="loading" v-if="loading">
      <div class="wrapper">
        <span class="spinner"></span>
        <p class="sr-only">Loading...</p>
      </div>
    </div>

    <div v-else-if="page" class="marketplace-page">
      <header class="marketplace-page--header">
        <div class="wrapper">
          <div class="marketplace-page--header--title">
            <h1 v-if="page.acf.hero_title">{{ page.acf.hero_title }}</h1>
            <h1 v-else v-html="page.title.rendered"></h1>
          </div>
        </div>
      </header>

      <div
        class="wrapper marketplace-page--content"
        v-html="page.content.rendered"
      ></div>

      <div
        class="wrapper marketplace-page--offers"
        v-if="page.acf.offer && page.acf.offer.length > 0"
      >
        <div v-for="offer in page.acf.offer" :key="offer.id" class="offer-item">
          <div class="offer-item--image">
            <img
              v-if="offer.image"
              :src="offer.image"
              :alt="offer.company.label"
              class="offer-image"
            />
          </div>
          <div class="offer-item--content">
            <img
              v-if="offer.logo"
              :src="offer.logo"
              :alt="offer.company.label"
              class="offer-logo"
            />
            <h2>{{ offer.amount }}</h2>
            <h3>{{ offer.company.label }}</h3>
            <div v-html="offer.description"></div>
            <template v-if="offer.button_text">
              <button
                @click="claimOffer(offer.company.value, offer.opens_new_window)"
                class="btn"
              >
                {{
                  offerLoading[offer.company.value]
                    ? 'Loading...'
                    : offer.button_text
                }}
              </button>
              <span class="button-after" v-html="offer.button_after" />
              <div class="alert" v-if="offerMessage[offer.company.value]">
                <p>{{ offerMessage[offer.company.value] }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketplacePage',
  data() {
    return {
      loading: true,
      page: null,
      offerLoading: {},
      offerMessage: {},
    };
  },
  computed: {
    error() {
      return this.$store.getters.getError;
    },
  },
  mounted() {
    this.$store.dispatch('getPage', 'marketplace').then(() => {
      this.page = this.$store.getters.getPage('marketplace');
      this.loading = false;
    });
  },
  methods: {
    claimOffer(companyId, openNewWindow = false) {
      const vm = this;
      vm.offerLoading[companyId] = true;
      this.$forceUpdate();

      let newWindow = null;
      if (openNewWindow) {
        newWindow = window.open('', '_blank');
      }
      vm.$store
        .dispatch('claimOffer', companyId)
        .then((response) => {
          if (
            response &&
            response.status === 200 &&
            response.data.redirect_url
          ) {
            if (newWindow) {
              newWindow.location = response.data.redirect_url;
            } else {
              // fallback if popup was still blocked
              window.open(response.data.redirect_url, '_blank');
            }
          } else if (response && response.status === 200) {
            vm.offerMessage[companyId] =
              'Offer claimed successfully! Check your email for details.';
          } else {
            vm.offerMessage[companyId] =
              this.$store.getters.getError ||
              'An error occurred while claiming the offer. Please try again later.';
          }
          vm.offerLoading[companyId] = false;
          vm.$forceUpdate();
        })
        .catch((e) => {
          console.error('Error claiming offer:', e);
          vm.offerMessage[companyId] =
            this.$store.getters.getError ||
            'An error occurred while claiming the offer. Please try again later.';
          vm.offerLoading[companyId] = false;
          vm.$forceUpdate();
        });
    },
  },
  metaInfo() {
    return {
      title: 'Marketplace',
    };
  },
};
</script>
